import React, { Component } from 'react'
import { Provider } from 'react-redux'
import {
  ConnectedRouter,
} from 'react-router-redux';
import { store, history } from './stores';
import { Route, Switch } from 'react-router'
import { routes } from './config/routes';
import { Header, Content, Footer, Modal } from './components';
import './App.css';

class App extends Component {
  render(){
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div>
            <Header />
            <Content>
              <Modal />
              <Switch>
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    exact={route.exact}
                    path={route.path}
                    component={route.component}
                    something="foo"
                  />
                ))}

              </Switch>
            </Content>
            <Footer />
          </div>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js